import axios from "axios";
import MyDataTable from "../utilities/MyDataTable";
import NewLink from "../utilities/NewLink";
import {format, parseJSON} from 'date-fns'
import {useQuery} from "@tanstack/react-query";
import Empty from "../utilities/Empty";
import {BASE_URL} from "../utilities/config";


const columns = [
    {
        name: 'Client',
        selector: row =>
            (
                <a className="hover:underline hover:text-blue-800 text-blue-600"
                   href={`clients/` + row.client_id}>{row.client_name}</a>
            ),
        sortable: true,
    },
    {
        name: 'Stock',
        selector: row =>
            (
                <a className="hover:underline hover:text-blue-800 text-blue-600"
                   href={`inventory/` + row.stock_id}>{row.stock_name}</a>
            ),
        sortable: true,
    },
    {
        name: 'Quantity',
        selector: row => `${row.quantity} ${row.stock_units}`,
        sortable: true,
    },
    {
        name: 'Date & Time',
        selector: row => row.updated_at,
        format: row => format(parseJSON(row.updated_at), 'PPpp'),
        sortable: true,
    },
];

export const Incoming = () => {

    const {isLoading, data, isError, error} = useQuery(['incoming'], () => {
        return axios.get(`${BASE_URL}/transactions/incoming/`);
    });

    if (isLoading) {
        return (
            <>
                <NewLink>New Incoming Inventory</NewLink>
                <div className="mx-auto bg-gray-700 py-12 rounded-lg">
                    <Empty>
                        <p className="py-4 text-xl text-amber-600">Incoming transactions data is loading...</p>
                    </Empty>
                </div>
            </>
        )
    }

    if (isError) {
        return (
            <Empty>
                <p className="text-red-500 hover:text-red-600 text-xl">{error.message}</p>
            </Empty>
        )
    }


    return (
        <>
            <NewLink>New Incoming Inventory</NewLink>
            <MyDataTable
                columns={columns}
                data={data.data}
                filter={'client_name'}
                title={'Incoming Stock Transactions List'}
            />
        </>
    );
};

export default Incoming;
